import React from 'react';
import { installDecommissionApi } from '../services/api';
import { InstallPhaseWorkspace, InstallPhaseConfig } from './InstallPrepTask';

const INSTALL_DECOM_CONFIG: InstallPhaseConfig = {
  phase: 'DECOMMISSION',
  api: installDecommissionApi,
  copy: {
    caseLabel: 'Decommission / Repack',
    totalTimeLabel: 'Total decommission time (hours)',
    headerStatus: {
      IN_PROGRESS: 'In decommission',
      ON_HOLD: 'On hold',
      COMPLETED: 'Ready for removal'
    },
    statusButtonLabels: {
      IN_PROGRESS: 'In decommission',
      ON_HOLD: 'On hold',
      COMPLETED: 'Ready'
    },
    summaryPlaceholder: 'Generate a summary of decommission activities for quality and logistics.',
    summaryGenerateLabel: 'Generate summary',
    summaryGeneratingLabel: 'Generating...',
    summaryEditLabel: 'Edit summary',
    summaryNoDataLabel: 'No decommission summary yet.',
    runNotesLabel: 'Decommission notes',
    markCompleteButtonLabel: 'Mark ready for removal',
    loadingMessage: 'Loading decommission checklist...',
    loadError: 'Failed to load decommission task',
    saveError: 'Failed to save decommission task'
  },
  preInstallCheck: {
    title: 'Verification handoff',
    description: 'Verification status before decommission begins.',
    badgeLabels: {
      COMPLETE: 'Verified complete',
      NOT_REQUIRED: 'Not required',
      INCOMPLETE: 'Verification incomplete',
      INCOMPLETE_WITH_REASON: 'Incomplete with note',
      PARTIAL: 'Verification partial',
      UNKNOWN: 'Pending'
    },
    outstandingTitle: 'Outstanding verification items',
    noteLabel: 'Technician note',
    actionLabel: 'Open verification workspace',
    actionPath: 'verify'
  },
  enforceLayout: 'site',
  disableStepNotes: true
};

const InstallDecommissionWorkspace: React.FC = () => {
  return <InstallPhaseWorkspace config={INSTALL_DECOM_CONFIG} />;
};

export default InstallDecommissionWorkspace;
